import { DataDocument, tagsTemplateDirectoryId } from '@fillip/api';

export const TemplateTagH6: DataDocument = {
  id: 'tag-h6',
  parentId: tagsTemplateDirectoryId,
  info: {
    title: 'Heading 6',
    // TODO: Replace with h6 after update to font awesome 6
    icon: 'heading',
    isProtected: true,
  },
  element: {
    type: 'element.text',
    textFormat: 'h6',
    textContent: ':$text',
  },
  class: {
    class: ':`${$containerClasses}`',
    elementClass: ':`${$elementClasses}`',
  },
  tag: {
    tag: 'tag',
  },
  tagDefinition: {
    tag: 'h6',
    title: 'Heading 6',
    category: 'content',
    // TODO: Replace with h6 after update to font awesome 6
    icon: 'heading',
    editor: 'h6',
  },
  interfaceDefinition: {
    title: '',
    inheritFrom: 'baseContent',
    props: [
      {
        title: 'Container Classes',
        key: 'containerClasses',
        type: 'string',
        defaultValue:
          ":`${$$contentTagClasses} ${$$headlineClasses} text-base ${$containerClasses || properties?.containerClasses?.value || ''}`",
      },
      {
        title: 'Element Classes',
        key: 'elementClasses',
        type: 'string',
        defaultValue:
          ":`font-medium ${$elementClasses || properties?.elementClasses?.value || ''}`",
      },
    ],
  },
};
